import axios from 'axios'
import { validateSecureData, clearInvalidData } from '@/security/secureStorage';
import messages from './messages'

const http = axios
//TODO: VERIFICAR API ANTES DE ENVIAR PARA OUTRO AMBIENTE
// const baseURL = 'https://api.rqr.pwc.com.br'          //PRD ADV
// const baseURL = 'https://api.rqr-asr.pwc.com.br'          //PRD ASR
const baseURL = 'https://api.rqr.testenv.pwc.com.br'  //STAGE
// const baseURL = 'http://localhost:3333'                  //LOCAL

const requestOnAPI = axios.create({
  baseURL: baseURL,
  headers: {
    'Accept': 'application/json',
  },
  withCredentials: true
})

const loginURL = `${requestOnAPI.defaults.baseURL}/mock/authenticate`
const login = access_token => requestOnAPI.post(loginURL, { access_token })
// const setAPIToken = token => {
//   if (token) {
//       requestOnAPI.defaults.headers.common['Authorization'] = `Bearer ${token}`
//   } else {
//       delete requestOnAPI.defaults.headers.common['Authorization']
//   }
// }

const setInterceptors = function () {
  requestOnAPI.interceptors.response.use(
    response => response,
    async error => {
      if (error.response.status === 401) {
        // Verificar integridade dos dados sensíveis
        const userToken = window.sessionStorage.getItem('USERTOKEN');
        if (userToken) {
          try {
            const parsed = JSON.parse(userToken);
            if (parsed.encrypted && !(await validateSecureData(parsed))) {
              clearInvalidData();
              return Promise.reject(new Error('Invalid session data'));
            }
          } catch {
            clearInvalidData();
            return Promise.reject(new Error('Corrupted session data'));
          }
        }

        if (this.$route.name === 'Login') {
          this.$toast.warning('Not authorized');
        } else {
          this.$storage.clearStorage();
          this.$router.push({ name: 'Login' });
          this.$toast.warning(messages[error.response.status]);
        }
      } else {
        const message = messages[error.response.status];
        if (message) {
          this.$toast.warning(message);
        }
      }

      return Promise.reject(error);
    }
  );
}

const camelToSnake = function(obj) {
  if (typeof obj !== 'object' || obj === null)
    return obj;

  if (Array.isArray(obj))
    return obj.map(camelToSnake);

  return Object.keys(obj).reduce((acc, key) => {
    const snakeKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
    acc[snakeKey] = camelToSnake(obj[key]);
    return acc;
  }, {});
};

export { http, requestOnAPI, login, setInterceptors,camelToSnake }
